// Compare to ../ServerRouterApp.jsx
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import finalCreateStore from '../store/organizationConfigStore';
import Routes from '../routes/routes';

const OrganizationConfigNewApp = (props, railsContext) => {
  const store = finalCreateStore(props, railsContext);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes props={props} />
      </BrowserRouter>
    </Provider>
  );
};

export default OrganizationConfigNewApp;
